export const MRZ_FIELDS = {
  MRZ_1: "mrzLine1",
  MRZ_2: "mrzLine2",
  MRZ_3: "mrzLine3"
};
